import type { CountryCode } from "@config/site/types";

/**
 * Azores & Madeira (remote Portuguese islands) use postcodes in the `9XXX-XXX` range.
 * Standard carriers cannot deliver there — only DHL Express can — so checkout must
 * restrict the available delivery methods for these addresses.
 *
 * This is intentionally scoped to the PT market only: for any other country the
 * function short-circuits to `false` before the postcode is ever inspected.
 */
export const isRemotePortugalIslandPostalCode = (
    postalCode: string | null | undefined,
    country: CountryCode
): boolean => {
    if (country !== "PT") return false;
    return (postalCode?.trim() ?? "").startsWith("9");
};
